module.exports = __webpack_public_path__ + "media/images/16x16-9e4d9c14.png";